import LoginText from "./LoginText";

export default LoginText;
